import {
  RangeSlider,
  RangeSliderFilledTrack,
  RangeSliderMark,
  RangeSliderThumb,
  RangeSliderTrack,
  Text,
} from '@chakra-ui/react';
import cn from 'classnames/bind';
import React from 'react';

import { PriceFormat } from '@/app/_components/price-format/price-format';

import { InputsSeparator } from '../inputs-separator/inputs-separator';
import { PriceInput } from '../price-input/price-input';
import { SectionName } from '../section-name/section-name';

import styles from './price.module.scss';

const cx = cn.bind(styles);

export const Price: React.FC<{
  showInCarFinder?: boolean;
  defaultPriceFilter: { min: number; max: number };
  currentFilter: { min: number; max: number };
  onChange: (value: { min: number; max: number }) => void;
  onCommit: (value: { min: number; max: number }) => void;
}> = ({
  showInCarFinder,
  defaultPriceFilter,
  currentFilter,
  onChange,
  onCommit,
}) => {
  //  const handleMinValue = useCallback(
  //   (value: number) => {
  //     const min = Math.max(
  //       defaultPriceFilter.min,
  //       Math.min(value, currentFilter.max),
  //     );

  //     onChange({
  //       min,
  //       max: currentFilter.max,
  //     });
  //   },
  //   [
  //     currentFilter.max,
  //     defaultPriceFilter.min,
  //     onChange,
  //   ],
  // );

  // const handleMaxValue = useCallback(
  //   (value: number) => {
  //     const max = Math.min(
  //       defaultPriceFilter.max,
  //       Math.max(value, currentFilter.min),
  //     );

  //     onChange({
  //       min: currentFilter.min,
  //       max,
  //     });
  //   },
  //   [
  //     currentFilter.min,
  //     defaultPriceFilter.max,
  //     onChange,
  //   ],
  // );

  return (
    <div
      className={cx(
        styles.priceWrapper,
        { carFinderWrapper: Boolean(showInCarFinder) }
      )}
    >
      <div className={styles.priceColumn}>
        <div className={styles.sectionWrapper}>
          <SectionName>Price Range</SectionName>

          <div className={styles.rangesWrapper}>
            <PriceInput
              prefix="R"
              value={currentFilter.min}
              step={5000}
              onChange={(min) =>
                onChange({ min, max: currentFilter.max })
              }
              onCommit={() => onCommit(currentFilter)}
              disabled
            />

            <InputsSeparator />

            <PriceInput
              prefix="R"
              value={currentFilter.max}
              step={5000}
              onChange={(max) =>
                onChange({ min: currentFilter.min, max })
              }
              onCommit={() => onCommit(currentFilter)}
              disabled
            />
          </div>
        </div>

        <RangeSlider
          step={10000}
          min={defaultPriceFilter.min}
          max={defaultPriceFilter.max}
          value={[currentFilter.min, currentFilter.max]}
          onChange={([min, max]) =>
            onChange({
              min: min ?? defaultPriceFilter.min,
              max: max ?? defaultPriceFilter.max,
            })
          }
          onChangeEnd={([min, max]) =>
            onCommit({
              min: min ?? defaultPriceFilter.min,
              max: max ?? defaultPriceFilter.max,
            })
          }
        >
          <RangeSliderTrack bg="gray.100">
            <RangeSliderFilledTrack bg="black" />
          </RangeSliderTrack>

          <RangeSliderThumb index={0} boxSize={6} border="1px solid black" />
          <RangeSliderThumb index={1} boxSize={6} border="1px solid black" />

          <RangeSliderMark value={defaultPriceFilter.min}>
            <Text className={styles.priceFormatText}>
              <PriceFormat prefix="R" value={defaultPriceFilter.min} />
            </Text>
          </RangeSliderMark>

          <RangeSliderMark
            value={defaultPriceFilter.max}
            style={{ transform: 'translateX(-100%)' }}
          >
            <Text className={styles.priceFormatText}>
              <PriceFormat prefix="R" value={defaultPriceFilter.max} />
            </Text>
          </RangeSliderMark>
        </RangeSlider>
      </div>

        {/* {!showInCarFinder && (
        <div className={styles.partWrapper}>
          <PriceFilterPromo />
        </div>
      )} */}
    </div>
  );
};

